import { keepTwoNull } from '@/utils/utils';
import { V2PowerRoomConfigCircuitDataPostResponse } from '@maxtropy/device-customer-apis-v2';
import dayjs from 'dayjs';
import * as echarts from 'echarts';
import { backgroundClip } from 'html2canvas/dist/types/css/property-descriptors/background-clip';

export const getChartPowerOption = (data?: V2PowerRoomConfigCircuitDataPostResponse) => {
  let powerData = (data?.circuitDataInfoList ?? []).map(item => [
    dayjs(item.time).valueOf(),
    keepTwoNull(item.activePower),
  ]);

  const areaColors = [
    new echarts.graphic.LinearGradient(0, 0, 0, 1, [
      { offset: 0, color: 'rgba(255,203,71,0.2)' },
      { offset: 1, color: 'rgba(255,203,71,0.1)' },
    ]),
  ];

  return {
    backgroundColor: 'transparent',
    tooltip: {
      formatter: (items: any) => {
        let { axisValue } = items[0];
        let firstStr = dayjs(axisValue).format('YYYY-MM-DD HH:mm:ss');
        let otherStr = '';
        let str = '';

        items.forEach((item: any) => {
          const { seriesName, data, marker } = item;
          otherStr += `<div style="margin-top:8px"><div style="display:flex;justify-content:space-between;align-items:center;"><div><span>${marker}</span>${seriesName}</div><div>${
            data[1] || data[1] === 0 ? data[1] : '-'
          }kW</div></div>`;
          str = firstStr + otherStr;
        });

        return str;
      },
    },
    grid: {
      top: 60,
      bottom: 40,
      containLabel: true,
    },
    legend: {
      right: 0,
      top: 10,
      bottom: 0,
      icon: 'rect',
      itemWidth: 16,
      itemHeight: 4,
      itemGap: 24,
      padding: [0, 8, 0, 0],
    },
    xAxis: [
      {
        type: 'time',
        axisLabel: {
          formatter: function (e: number) {
            return dayjs(e, 'x').format('HH:mm');
          },
        },
      },
    ],
    yAxis: [
      {
        type: 'value',
        name: 'kW',
        axisLabel: {
          formatter: '{value}',
        },
      },
    ],
    series: [
      {
        name: '有功功率',
        type: 'line',
        data: powerData,
        connectNulls: true,
        smooth: true,
        showSymbol: false,
        itemStyle: {
          color: '#FFCB47',
        },
        areaStyle: {
          color: areaColors[0],
        },
      },
    ],
  };
};

export const getChartVoltageOption = (data?: V2PowerRoomConfigCircuitDataPostResponse) => {
  let AData = (data?.circuitDataInfoList ?? []).map(item => [dayjs(item.time).valueOf(), keepTwoNull(item.voltageAb)]);
  let BData = (data?.circuitDataInfoList ?? []).map(item => [dayjs(item.time).valueOf(), keepTwoNull(item.voltageBc)]);
  let CData = (data?.circuitDataInfoList ?? []).map(item => [dayjs(item.time).valueOf(), keepTwoNull(item.voltageCa)]);

  return {
    backgroundColor: 'transparent',
    tooltip: {
      formatter: (items: any) => {
        let { axisValue } = items[0];
        let firstStr = dayjs(axisValue).format('YYYY-MM-DD HH:mm:ss');
        let otherStr = '';
        let str = '';

        items.forEach((item: any) => {
          const { seriesName, data, marker } = item;
          otherStr += `<div style="margin-top:8px"><div style="display:flex;justify-content:space-between;align-items:center;"><div><span>${marker}</span>${seriesName}</div><div>${
            data[1] || data[1] === 0 ? data[1] : '-'
          }V</div></div>`;
          str = firstStr + otherStr;
        });

        return str;
      },
    },
    grid: {
      left: 10,
      right: 10,
      top: 60,
      bottom: 40,
      containLabel: true,
    },
    legend: {
      right: 0,
      top: 10,
      bottom: 0,
      icon: 'rect',
      itemWidth: 16,
      itemHeight: 4,
      itemGap: 24,
      padding: [0, 8, 0, 0],
    },
    xAxis: [
      {
        type: 'time',
        axisLabel: {
          formatter: function (e: number) {
            return dayjs(e, 'x').format('HH:mm');
          },
        },
      },
    ],
    yAxis: [
      {
        type: 'value',
        name: 'V',
        axisLabel: {
          formatter: '{value}',
        },
      },
    ],
    series: [
      {
        name: 'AB线电压',
        type: 'line',
        data: AData,
        connectNulls: true,
        smooth: true,
        showSymbol: false,
        itemStyle: {
          color: '#FFCB47',
        },
      },
      {
        name: 'BC线电压',
        type: 'line',
        data: BData,
        connectNulls: true,
        smooth: true,
        showSymbol: false,
        itemStyle: {
          color: '#59D744',
        },
      },
      {
        name: 'CA线电压',
        type: 'line',
        showSymbol: false,
        data: CData,
        connectNulls: true,
        smooth: true,
        itemStyle: {
          color: '#FF4D4F',
        },
      },
    ],
  };
};

export const getChartCurrentOption = (data?: V2PowerRoomConfigCircuitDataPostResponse) => {
  let AData = (data?.circuitDataInfoList ?? []).map(item => [
    dayjs(item.time).valueOf(),
    keepTwoNull(item.electricCurrentA),
  ]);
  let BData = (data?.circuitDataInfoList ?? []).map(item => [
    dayjs(item.time).valueOf(),
    keepTwoNull(item.electricCurrentB),
  ]);
  let CData = (data?.circuitDataInfoList ?? []).map(item => [
    dayjs(item.time).valueOf(),
    keepTwoNull(item.electricCurrentC),
  ]);

  return {
    backgroundColor: 'transparent',
    tooltip: {
      formatter: (items: any) => {
        let { axisValue } = items[0];
        let firstStr = dayjs(axisValue).format('YYYY-MM-DD HH:mm:ss');
        let otherStr = '';
        let str = '';

        items.forEach((item: any) => {
          const { seriesName, data, marker } = item;
          otherStr += `<div style="margin-top:8px"><div style="display:flex;justify-content:space-between;align-items:center;"><div><span>${marker}</span>${seriesName}</div><div>${
            data[1] || data[1] === 0 ? data[1] : '-'
          }A</div></div>`;
          str = firstStr + otherStr;
        });

        return str;
      },
    },
    grid: {
      left: 10,
      right: 10,
      top: 60,
      bottom: 40,
      containLabel: true,
    },
    legend: {
      right: 0,
      top: 10,
      bottom: 0,
      icon: 'rect',
      itemWidth: 16,
      itemHeight: 4,
      itemGap: 24,
      padding: [0, 8, 0, 0],
    },
    xAxis: [
      {
        type: 'time',
        axisLabel: {
          formatter: function (e: number) {
            return dayjs(e, 'x').format('HH:mm');
          },
        },
      },
    ],
    yAxis: [
      {
        type: 'value',
        name: 'A',
        axisLabel: {
          formatter: '{value}',
        },
      },
    ],
    series: [
      {
        name: 'A相电流',
        type: 'line',
        data: AData,
        connectNulls: true,
        smooth: true,
        showSymbol: false,
        itemStyle: {
          color: '#FFCB47',
        },
      },
      {
        name: 'B相电流',
        type: 'line',
        data: BData,
        connectNulls: true,
        smooth: true,
        showSymbol: false,
        itemStyle: {
          color: '#59D744',
        },
      },
      {
        name: 'C相电流',
        type: 'line',
        showSymbol: false,
        data: CData,
        connectNulls: true,
        smooth: true,
        itemStyle: {
          color: '#FF4D4F',
        },
      },
    ],
  };
};
